const {
  REACT_APP_KAKAO_LOGIN_HOST,
  REACT_APP_BUSINESS_HOST,
  REACT_APP_CRUX_BIZ_AUTH_HOST,
} = process.env

export const kakaoLogin = () => {
  window.location.href = `${REACT_APP_KAKAO_LOGIN_HOST}/login?continue=${window.location.href}`
}

export const kakaoLogout = () => {
  window.location.href = `${REACT_APP_KAKAO_LOGIN_HOST}/logout?continue=${REACT_APP_BUSINESS_HOST}`
}

export const cruxAccountJoin = () => {
  window.location.replace(
    `${REACT_APP_CRUX_BIZ_AUTH_HOST}/account/auth?after=${window.location.href}&from=KEYWORDAD`
  )
}
